<template>
  <div v-if="!pageLoading" class="bg-[#FCFCFD]">
    <router-view></router-view>
  </div>
  <div v-else class="flex items-center justify-center w-screen h-screen p-10">
    <div class="flex flex-col items-center justify-center text-center gap-y-6">
      <AppLoaderV2 />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, provide } from "vue";
import { setItem, getItem } from "@/utils/localStorageControl.js";
import { getSubApps } from "@/services/userservices";
import cookieUtils from "@/utils/Cookies";
import { AppCodes } from "@/utils/constants";
import AppLoaderV2 from "./components/AppLoaderV2.vue";
import { useEncryption } from "@/utils/useEncryption";

const { encrypt } = useEncryption();
const pageLoading = ref(false);
const selectedApp = ref(getItem("selectedApp") ?? AppCodes.matta);

// ✅ Get data function optimized
async function getData() {
  const token = cookieUtils.get("token");
  if (!token) return;

  try {
    const res = await getSubApps();
    if (res.status === 200) {
      const appList = res.data.data.map((app) => {
        let baseUrl = app.url.replace("https://", "https://admin.");
        if (baseUrl.includes("app.")) {
          baseUrl = baseUrl.replace("app.", "");
        }

        return {
          ...app,
          url: baseUrl,
          linkUrl: `${baseUrl}/auth/validate?code=${encodeURIComponent(
            encrypt(token)
          )}`,
        };
      });
      setItem("appList", appList);
    }
  } catch (error) {
    console.error("Error fetching app data:", error);
  }
}

// ✅ Switch App function
function switchApp(value) {
  setItem("selectedApp", value);
  selectedApp.value = value;
}

// ✅ onBeforeMount with efficient checks
onBeforeMount(async () => {
  const token = cookieUtils.get("token");
  if (!token) {
    pageLoading.value = false;
    return;
  }

  if (!getItem("selectedApp")) {
    setItem("selectedApp", process.env.VUE_APP_MATTA_APP_CODE);
  }
  if (token) {
    await getData();
  }
});

// ✅ Provide global state
provide("selectedApp", selectedApp);
provide("switchApp", switchApp);
</script>

<style>
label,
.input-label {
  color: #344054 !important;
  font-size: 14px;
  margin-bottom: 6px;
}
</style>
